const hblp_buybox = {

  init: () => {

    if ($('.hblp-buybox__slider')[0]) {
      $('.hblp-buybox__slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrows: false,
        // centerMode: true,
        adaptiveHeight: true,
        autoplay: true,
        autoplaySpeed: 5000,
        speed: 500,
        infinite: true,
        cssEase: 'linear',
        waitForAnimate: false,
        pauseOnHover: false,
      });
    }

    // Handle UI
    $('.hblp-buybox__product-btn').on('click', function() {
      $('.hblp-buybox__product-btn').attr('data-selected', false)
      $(this).attr('data-selected', true)
      updateATCPrice()
    })

    $('.hblp-buybox__gift-btn').on('click', function() {
      $('.hblp-buybox__gift-btn').attr('data-selected', false)
      $(this).attr('data-selected', true)
      updateATCPrice()
    })

    // Update ATC Price
    function updateATCPrice() {
      let prodPrice   = $('.hblp-buybox__product-btn[data-selected="true"]').data('price')
      let prodQty     = $('.hblp-buybox__product-btn[data-selected="true"]').data('quantity')
      let giftPrice   = $('.hblp-buybox__gift-btn[data-selected="true"]').data('price')
      let giftQty     = $('.hblp-buybox__gift-btn[data-selected="true"]').data('quantity')
      let total       = (((prodPrice * prodQty) + (giftPrice * giftQty)) / 100).toFixed(2)
      $('#addToCart [data-price]').text(total)
      
    }
    updateATCPrice()

    $('#addToCart').on('click', function() {

      var hs_id =  Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);

      let prodVariantId = $('.hblp-buybox__product-btn[data-selected="true"]').data('variant-id')
      let prodQty = $('.hblp-buybox__product-btn[data-selected="true"]').data('quantity')
      let merchVariantId = $('.hblp-buybox__gift-btn[data-selected="true"]').data('variant-id')
      let merchQty = $('.hblp-buybox__gift-btn[data-selected="true"]').data('quantity')

      add_product()

      function add_product() {
        var data = {
            "quantity": prodQty,
            "id": prodVariantId,
            "properties[_hs_sub_product]": true,
            "properties[_hslp_qualifying]": true,
            "properties[_hs_id]": hs_id
        };
        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          dataType: 'json',
          data: data,
          success: function(res){
            add_merch();
          },
          error: function(){
            console.log('Error adding HBLP product to cart');
          }
        });
      }

      function add_merch() {
        var data = {
            "quantity": merchQty,
            "id": merchVariantId,
            "properties[_hslp_merch]": true,
            "properties[_hs_id]": hs_id,
        };
        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          dataType: 'json',
          data: data,
          success: function(res){
            console.log('Successfully added to Cart');
            // window.SLIDECART_UPDATE();
            // window.SLIDECART_OPEN();
            window.LSG_OPEN_CART();
          },
          error: function(){
            console.log('Error adding HBLP gift to cart');
          }
        });
      }

    })

  }

};
export default hblp_buybox;